import React from 'react';

import { I18n } from 'components/translate';
import PropTypes from 'prop-types';

import './fieldError.scss';

const FieldError = ({ error, data }) => {
  if (!error) {
    return null;
  }

  return (
    <p className="error">
      <I18n label={`validations.${error}`} data={data} />
    </p>
  );
};

FieldError.propTypes = {
  error: PropTypes.string,
  data: PropTypes.object
};

export default FieldError;
